export default __webpack_public_path__ + "static/media/gnl7.33da04ef.jpg";